(function () {
  'use strict';

  var scriptId = 'hg-stamped-widget-script';
  var stampedSource = 'https://cdn1.stamped.io/files/widget.min.js';
  var sectionObservers = new WeakMap();
  var sectionTimers = new WeakMap();

  function setStatus(section, message) {
    var status = section.querySelector('[data-hg-stamped-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  function getReviewCards(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('.stamped-review, .stamped-review-card')
    );
  }

  function getText(card, selector) {
    var element = card.querySelector(selector);
    return element ? element.textContent.trim() : '';
  }

  function getOriginalReviewBody(body) {
    var original = body.querySelector('.original-review');
    return original ? original.textContent.trim() : body.textContent.trim();
  }

  function getReviewData(card) {
    var title = card.querySelector('.stamped-review-title, .stamped-review-header-title');
    var body = card.querySelector('.stamped-reviews-message, .stamped-review-content-body');
    var location = card.querySelector('.stamped-reviews-location');
    var product = card.querySelector('.stamped-products-reviews-title a, .stamped-review-product');

    if (!card.id || !body) return null;

    return {
      id: card.id,
      titleElement: title,
      bodyElement: body,
      originalTitle: title ? title.textContent.trim() : '',
      originalBody: getOriginalReviewBody(body),
      originalLocation: location ? location.textContent.trim() : '',
      productName: product ? product.textContent.trim() : '',
      productUrl: product ? product.href : ''
    };
  }

  function getReviewFingerprint(data) {
    return data.id;
  }

  function resetCardTranslation(card) {
    card.removeAttribute('data-hg-translation-state');
    card.removeAttribute('data-hg-review-language');
    card.removeAttribute('data-hg-original-title');
    card.removeAttribute('data-hg-original-body');
    card.removeAttribute('data-hg-original-location');
    card.removeAttribute('data-hg-review-fingerprint');

    var source = card.querySelector('[data-hg-review-source]');
    if (source) source.remove();
  }

  function prepareCard(card, data) {
    var fingerprint = getReviewFingerprint(data);
    if (card.getAttribute('data-hg-review-fingerprint') !== fingerprint) {
      resetCardTranslation(card);
      card.setAttribute('data-hg-review-fingerprint', fingerprint);
    }
  }

  function createSourceDetails(card, data) {
    var existing = card.querySelector('[data-hg-review-source]');
    if (existing) return existing;

    var source = document.createElement('div');
    source.className = 'hg-review-source';
    source.setAttribute('data-hg-review-source', '');

    if (data.originalLocation) {
      var location = document.createElement('span');
      location.className = 'hg-review-source__item';
      location.appendChild(document.createTextNode('評價者來自：'));
      var locationValue = document.createElement('strong');
      locationValue.setAttribute('data-hg-review-location', '');
      locationValue.textContent = data.originalLocation;
      location.appendChild(locationValue);
      source.appendChild(location);
    }

    if (data.productName) {
      var product = document.createElement('span');
      product.className = 'hg-review-source__item';
      product.appendChild(document.createTextNode('評價產品：'));
      var productLink = document.createElement('a');
      productLink.href = data.productUrl;
      productLink.rel = 'nofollow';
      productLink.textContent = data.productName;
      product.appendChild(productLink);
      source.appendChild(product);
    }

    var toggle = document.createElement('button');
    toggle.className = 'hg-review-language-toggle';
    toggle.type = 'button';
    toggle.hidden = true;
    toggle.setAttribute('aria-pressed', 'false');
    toggle.textContent = '查看英文原文';
    source.appendChild(toggle);

    var author = card.querySelector('.stamped-reviews-author, .stamped-review-header-byline');
    if (author) {
      author.insertAdjacentElement('afterend', source);
    } else {
      card.appendChild(source);
    }

    return source;
  }

  function showTranslation(card, translated) {
    var title = card.querySelector('.stamped-review-title, .stamped-review-header-title');
    var body = card.querySelector('.stamped-reviews-message, .stamped-review-content-body');
    var location = card.querySelector('[data-hg-review-location]');
    var toggle = card.querySelector('.hg-review-language-toggle');
    if (!body || !toggle) return;

    if (title) title.textContent = translated.title;
    body.textContent = translated.body;
    if (location) location.textContent = translated.location;
    toggle.textContent = '查看英文原文';
    toggle.setAttribute('aria-pressed', 'false');
    toggle.hidden = false;
    card.setAttribute('data-hg-review-language', 'zh-Hant');
  }

  function showOriginal(card) {
    var title = card.querySelector('.stamped-review-title, .stamped-review-header-title');
    var body = card.querySelector('.stamped-reviews-message, .stamped-review-content-body');
    var location = card.querySelector('[data-hg-review-location]');
    var toggle = card.querySelector('.hg-review-language-toggle');
    if (!body || !toggle) return;

    if (title) title.textContent = card.getAttribute('data-hg-original-title') || '';
    body.textContent = card.getAttribute('data-hg-original-body') || '';
    if (location) location.textContent = card.getAttribute('data-hg-original-location') || '';
    toggle.textContent = '顯示中文翻譯';
    toggle.setAttribute('aria-pressed', 'true');
    card.setAttribute('data-hg-review-language', 'en');
  }

  function addLanguageToggle(card, translated) {
    var toggle = card.querySelector('.hg-review-language-toggle');
    if (!toggle || toggle.getAttribute('data-hg-toggle-ready') === 'true') return;

    toggle.setAttribute('data-hg-toggle-ready', 'true');
    toggle.addEventListener('click', function () {
      if (card.getAttribute('data-hg-review-language') === 'en') {
        showTranslation(card, translated);
      } else {
        showOriginal(card);
      }
    });
  }

  function markTranslationUnavailable(card) {
    card.setAttribute('data-hg-translation-state', 'unavailable');
    var toggle = card.querySelector('.hg-review-language-toggle');
    if (toggle) toggle.hidden = true;
  }

  function translateVisibleReviews(section) {
    var endpoint = section.getAttribute('data-translation-endpoint');
    if (!endpoint) return;

    var pending = [];
    getReviewCards(section).forEach(function (card) {
      var data = getReviewData(card);
      if (!data) return;

      prepareCard(card, data);
      if (card.getAttribute('data-hg-translation-state')) return;

      card.setAttribute('data-hg-translation-state', 'loading');
      card.setAttribute('data-hg-original-title', data.originalTitle);
      card.setAttribute('data-hg-original-body', data.originalBody);
      card.setAttribute('data-hg-original-location', data.originalLocation);
      createSourceDetails(card, data);
      pending.push({ card: card, data: data });
    });

    if (!pending.length) return;

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        reviews: pending.map(function (item) {
          return {
            id: item.data.id,
            title: item.data.originalTitle,
            body: item.data.originalBody,
            location: item.data.originalLocation
          };
        })
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Translation request failed.');
        return response.json();
      })
      .then(function (result) {
        var translations = new Map();
        (result.translations || []).forEach(function (translation) {
          translations.set(translation.id, translation);
        });

        pending.forEach(function (item) {
          var translated = translations.get(item.data.id);
          if (!translated) {
            markTranslationUnavailable(item.card);
            return;
          }
          item.card.setAttribute('data-hg-translation-state', 'ready');
          showTranslation(item.card, translated);
          addLanguageToggle(item.card, translated);
        });
      })
      .catch(function () {
        pending.forEach(function (item) {
          markTranslationUnavailable(item.card);
        });
      });
  }

  function revealStampedReviews(section) {
    if (!getReviewCards(section).length) return false;
    getReviewCards(section).forEach(function (card) {
      var data = getReviewData(card);
      if (data) prepareCard(card, data);
    });
    section.classList.add('hg-all-reviews--ready');
    setStatus(section, '');
    translateVisibleReviews(section);
    return true;
  }

  function scheduleReviewUpdate(section) {
    var previousTimer = sectionTimers.get(section);
    if (previousTimer) window.clearTimeout(previousTimer);
    sectionTimers.set(section, window.setTimeout(function () {
      revealStampedReviews(section);
    }, 80));
  }

  function watchForReviews(section) {
    revealStampedReviews(section);
    var previousObserver = sectionObservers.get(section);
    if (previousObserver) previousObserver.disconnect();

    var observer = new MutationObserver(function () {
      scheduleReviewUpdate(section);
    });
    observer.observe(section, { childList: true, subtree: true });
    sectionObservers.set(section, observer);
  }

  function initializeStamped(section) {
    if (!section || !window.StampedFn) return;

    window.StampedFn.init({
      apiKey: section.getAttribute('data-stamped-api-key'),
      sId: section.getAttribute('data-stamped-store-id')
    });
    watchForReviews(section);
  }

  function loadStamped(section) {
    if (window.StampedFn) {
      initializeStamped(section);
      return;
    }

    var existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.addEventListener('load', function () {
        initializeStamped(section);
      }, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.id = scriptId;
    script.src = stampedSource;
    script.async = true;
    script.addEventListener('load', function () {
      initializeStamped(section);
    }, { once: true });
    script.addEventListener('error', function () {
      setStatus(section, '');
    }, { once: true });
    document.head.appendChild(script);
  }

  function start() {
    var sections = document.querySelectorAll('[data-hg-stamped-reviews]');
    Array.prototype.forEach.call(sections, loadStamped);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
